module.exports = __webpack_public_path__ + "img/nav-vehicle-models-homepage-honda.dd103ee9.png";